/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_TerminalInputs */

const en_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Terminal`)
};

const es_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar terminal`)
};

const fr_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres`)
};

const de_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal speichern`)
};

const ja_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を保存`)
};

const zh_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存终端设置`)
};

const ar_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ الإعدادات`)
};

const id_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan Terminal`)
};

const it_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva Terminale`)
};

const ru_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить настройки`)
};

const pt_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar Terminal`)
};

const ko_save_terminal = /** @type {(inputs: Save_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정 저장`)
};

/**
* | output |
* | --- |
* | "Save Terminal" |
*
* @param {Save_TerminalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const save_terminal = /** @type {((inputs?: Save_TerminalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_TerminalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_terminal(inputs)
	if (locale === "es") return es_save_terminal(inputs)
	if (locale === "fr") return fr_save_terminal(inputs)
	if (locale === "de") return de_save_terminal(inputs)
	if (locale === "ja") return ja_save_terminal(inputs)
	if (locale === "zh") return zh_save_terminal(inputs)
	if (locale === "ar") return ar_save_terminal(inputs)
	if (locale === "id") return id_save_terminal(inputs)
	if (locale === "it") return it_save_terminal(inputs)
	if (locale === "ru") return ru_save_terminal(inputs)
	if (locale === "pt") return pt_save_terminal(inputs)
	return ko_save_terminal(inputs)
});